// Layouts
import CircularEconomyDashboard from "./layouts/CircularEconomyDashboard";

import CertificateOfRegistrationList from "./pages/CertificateOfRegistration/List";
import CertificateOfRegistrationDetails from "./pages/CertificateOfRegistration/Details";

// Protected routes
import CircularEconomyHome from "./pages/home/ByProduct";
import CircularEconomyDetails from "./pages/home/Details/details";
import DetailsEndOfWaste from "./pages/home/Details/detailseow";
import EowHome from "./pages/home/EndOfWaste";

const routes = [
  {
    path: "/",
    element: <CircularEconomyDashboard />,
    children: [
      {
        path: "",
        element: <CircularEconomyHome />,
      },
      {
        path: "notifier/:notifierId",
        element: <CircularEconomyDetails />,
      },
      {
        path: "endofwaste",
        element: <EowHome />,
      },
      {
        path: "eow/:notifierId",
        element: <DetailsEndOfWaste />,
      },
      {
        path: "certificatesofregistration",
        element: <CertificateOfRegistrationList />,
      },
      {
        path: "cor/:licenseId",
        element: <CertificateOfRegistrationDetails />,
      },
    ],
  },
];

export default routes;
